export default __webpack_public_path__ + "static/media/gallery_06.6ed83edf.jpg";